module.exports = __webpack_public_path__ + "img/tl.2826c4e9.svg";